import { cn } from '../../lib/cn';
import type { DemoEnvRow } from '../../customersuccess/framework';

type Props = { environments?: DemoEnvRow[] };

export function DemoSandboxPanel({ environments = [] }: Props) {
  return (
    <div className="space-y-2">
      {environments.map((e) => (
        <div key={e.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{e.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{e.feature}</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              e.status === 'active' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {e.status}
            </span>
            {e.users > 0 && <p className="mt-1 text-xs text-slate-500">{e.users} users</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
